import { Controller } from "@hotwired/stimulus"

// Tracks clicks on search results for A/B testing relevance metrics
// Connects to data-controller="search-click-tracking"
export default class extends Controller {
  static values = {
    page: { type: Number, default: 1 },
    renderTime: Number,
    variant: String
  }

  static targets = ["result"]

  connect() {
    // Record page render time for time-to-click calculation
    this.renderTimeValue = Date.now()

    // Log the current A/B test variant to console
    console.log(`[Search A/B Test] Variant: ${this.variantValue || 'not set'}`)
  }

  trackClick(event) {
    // Only track if user clicked on a link (not whitespace)
    if (!event.target.closest('a')) return

    const result = event.currentTarget
    const photoId = result.dataset.searchPhotoId
    const productId = result.dataset.searchProductId
    const position = parseInt(result.dataset.searchPosition, 10)
    const timeToClick = Date.now() - this.renderTimeValue

    const params = new URLSearchParams({
      photo_id: photoId || '',
      product_id: productId || '',
      position,
      page: this.pageValue,
      time_to_click_ms: timeToClick
    })

    // sendBeacon is designed for exactly this use case:
    // - Non-blocking (doesn't delay navigation)
    // - Browser guarantees delivery even during page unload
    // - Returns false only if beacon queue is full (rare)
    if (navigator.sendBeacon) {
      const queued = navigator.sendBeacon('/search/clicks', params)
      if (!queued) {
        this.#sendWithFetch(params)
      }
    } else {
      this.#sendWithFetch(params)
    }
  }

  #sendWithFetch(params) {
    fetch('/search/clicks', {
      method: 'POST',
      body: params,
      keepalive: true
    }).catch(() => {})
  }
}
